<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card
      v-card-title.px-4(v-if="step !== 2")
        v-btn(icon color="neutral700" @click="handleBack")
          v-icon mdi-arrow-left
        v-spacer
        .text-md.font-semibold.ml-n4 Redeem rewards
        v-spacer
      v-divider(v-if="step !== 2")
      v-card-text
        template(v-if="step === 0")
          reward-to-redeem(v-model="selectedReward" :loyaltySystem="loyaltySystem" :profile="profile")
        template(v-if="step === 1")
          verification-code.mt-16(v-model="otp" itemText="reward" :phoneNumber="profile.phone")
        template(v-if="step === 2")
          redeem-reward-finish.mt-8(:loyalty-system="loyaltySystem" :customer="{ name: profile.name, phone: profile.phone }" :member="{ pid: profile.pid }" :redeemedReward="selectedReward" @close="handleRewardRedeemed")
      v-card-actions
        v-btn.button-md.white--text(v-if="step !== 2" :loading="isLoading" depressed :disabled="!canProceed" block color="neutral700" @click="handleContinue") Redeem
</template>

<script>

import CollectionProfile from "@/components/marketing/merchantapp/collect/CollectionProfile.vue";
import RedeemRewardListItem from "@/components/marketing/merchantapp/redeem/RedeemRewardListItem.vue";
import RewardToRedeem from "@/components/marketing/merchantapp/redeem/RewardToRedeem.vue";
import VerificationCode from "@/components/marketing/merchantapp/redeem/VerificationCode.vue";
import RedeemRewardFinish from "@/components/marketing/merchantapp/redeem/RedeemRewardFinish.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    RedeemRewardFinish,
    VerificationCode,
    RewardToRedeem,
    RedeemRewardListItem,
    CollectionProfile,
  },
  props: {
    open: {
      type: Boolean,
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedReward: null,
      step: 0,
      otp: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    canProceed() {
      if (this.step === 0) {
        return this.selectedReward !== null
      }
      if (this.step === 1) {
        return this.otp !== null && this.otp.length === 4
      }
      return true
    },
    otpRequestPayload() {
      return {
        phone: this.profile.phone,
        event: 'loyalty reward'
      }
    },
    otpCheckPayload() {
      return {
        phone: this.profile.phone,
        otp: `${this.otp}`
      }
    },
    redeemRewardPayload() {
      return {
        reward: this.selectedReward?.id,
        type: 'rewards',
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    async handleContinue() {
      if (this.step === 0) {
        const requested = await this.requestOTP()
        if (!requested) return
        this.step = 1
        return
      }
      if (this.step === 1) {
        const isValidOTP = await this.checkOTP()
        if (!isValidOTP) return
        const redeemed = await this.redeemReward()
        if (!redeemed) return
        this.step = 2
        return
      }
      this.closeDialog()
    },
    handleBack() {
      if (this.step === 1) {
        this.step = 0
        return
      }
      this.closeDialog()
    },
    handleRewardRedeemed() {
      this.$emit('redeemed')
      this.closeDialog()
    },
    async requestOTP() {
      try {
        this.isLoading = true
        const url = `/marketing/${this.company.slug}/redeems/request_otp`
        const {data} = await this.$axios.post(url, this.otpRequestPayload)
        this.updateActivityLog(url, this.otpRequestPayload, data, 'POST', 'Redeem reward request OTP', null)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      } finally {
        this.isLoading = false
      }
    },
    async checkOTP() {
      const url = `/marketing/${this.company.slug}/redeems/check_otp`
      try {
        this.isLoading = true
        const {data} = await this.$axios.post(url, this.otpCheckPayload)
        this.updateActivityLog(url, this.otpCheckPayload, data, 'POST', 'Redeem reward check OTP - success')
        return true
      } catch (error) {
        if (error.response.status === 400) {
          this.updateActivityLog(url, this.otpCheckPayload, error.response.data, 'POST', 'Redeem reward check OTP - invalid TAC')
          this.showMessage(['error', 'Invalid TAC'])
        } else {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        }
        return false
      } finally {
        this.isLoading = false
      }
    },
    async redeemReward() {
      try {
        const url = `/loyalty/${this.company.slug}/members/${this.profile.id}/collects`
        const {data} = await this.$axios.post(url, this.redeemRewardPayload)
        this.updateActivityLog(url, this.redeemRewardPayload, data, 'POST', 'Redeem loyalty reward', data.id)
        return true
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return false
      }
    },
    updateActivityLog(endpoint, payload, response, method, activity, id, objectRef) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: objectRef || null,
        activity: `Merchant-app: ${activity}`,
        raw_data: {endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    },
  },
}
</script>

<style scoped>
</style>
